// Copyright (c) 2016 Deere & Company

import KeyValuePair, {getDefaultState as getKeyValueDefaultState} from './key-value-pair';
import t from 'tcomb';

const ClaimAdditionalFailureInfo = t.struct({
    downtime: KeyValuePair,
    dtacCase: t.String,
    dtacSolution: t.String,
    dtacUrl: t.maybe(t.String),
    failureArea: t.String,
    failureMode: KeyValuePair,
    failureModeComments: t.String,
    failurePartSerialNumber: t.maybe(t.String)
}, {
    name: 'ClaimAdditionalFailureInfo',
    strict: true
});

export const getDefaultState = () => new ClaimAdditionalFailureInfo({
    downtime: getKeyValueDefaultState(),
    dtacCase: '',
    dtacSolution: '',
    dtacUrl: '',
    failureArea: '',
    failureMode: getKeyValueDefaultState(),
    failureModeComments: '',
    failurePartSerialNumber: ''
});

export default ClaimAdditionalFailureInfo;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/claim-additional-failure-info.js